export const USER_ADD_DATA_SUCCESS = 'USER_ADD_DATA_SUCCESS';
export const USER_ADD_GOOGLE_DATA_SUCCESS = 'USER_ADD_GOOGLE_DATA_SUCCESS';

export const USER_REGISTRATION_REQUEST = 'USER_REGISTRATION_REQUEST';
export const USER_REGISTRATION_PAY_REQUEST = 'USER_REGISTRATION_PAY_REQUEST';
export const USER_REGISTRATION_SUCCESS = 'USER_REGISTRATION_SUCCESS';

export const USER_CHECK_LOGIN_REQUEST = 'USER_CHECK_LOGIN_REQUEST';
export const USER_CHECK_LOGIN_SUCCESS = 'USER_CHECK_LOGIN_SUCCESS';

export const USER_UPDATE_PROFILE_REQUEST = 'USER_UPDATE_PROFILE_REQUEST';
export const USER_UPDATE_PROFILE_SUCCESS = 'USER_UPDATE_PROFILE_SUCCESS';
export const USER_UPDATE_PROFILE_ERROR = 'USER_UPDATE_PROFILE_ERROR';

export const USER_SEND_FEEDBACK_REQUEST = 'USER_SEND_FEEDBACK_REQUEST';
export const USER_SEND_FEEDBACK_SUCCESS = 'USER_SEND_FEEDBACK_SUCCESS';
